import { useState, useEffect, useCallback, useMemo } from "react";
import { SimpleGrid, FormLabel, IconButton, Box, } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ViewIcon } from "@chakra-ui/icons";

import Loading from "../../../Component/Loading/loading";
import apiService from "../../../Method/Report/Report_Service";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../../assets/Table/TableTheme";
import { useDataContext } from "./../../../DataProvider";
import TableWidget from "../../../Component/Table/TableWidget";
import SalesDetails from "../../SALES_DETAILS";

const buildColumns = (t, onViewDetails) => [
  {
    name: "BILL_DATE",
    label: t("DATE"),
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        if (!value) return "";
        return value.split("T")[0];
      },
    },
  },
  {
    name: "BILL_NUMBER",
    label: t("BILL_NUMBER"),
    options: { filter: false, sort: false },
  },
  {
    name: "BILL_ORDER",
    label: t("Order_No"),
    options: { filter: false, sort: false },
  },
  {
    name: "TOT_QTY",
    label: t("TOT_QTY"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },
  {
    name: "TOT_SELL",
    label: t("TOT_SALES"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },

  },
  {
    name: "DISCOUNT_SELL",
    label: t("DISCOUNT_SELL"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },
  {
    name: "SERVICE_SELL",
    label: t("SERVICE_SELL"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },

  {
    name: "NET_NET_SALES",
    label: t("NET_NET_SALES"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },

  {
    name: "",
    label: t("VIEW_DETAILS"),
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_value, tableMeta) => {
        const rowIndex = tableMeta.rowIndex;
        const rowData = tableMeta?.tableData?.[rowIndex];
        const salesDetails = rowData?.SALES_DETAILS || [];

        return (
          <IconButton
            size="sm"
            className="View_Icon_Button"
            colorScheme="blue"
            aria-label="View details"
            icon={<ViewIcon />}
            onClick={() => onViewDetails(salesDetails)}
          />
        );
      },
    },
  },
];

function App() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const { trigger } = useDataContext();
  const [searchText, setSearchText] = useState("");
  const [selectedDetails, setSelectedDetails] = useState(null);
  const handleViewDetails = useCallback((details) => { setSelectedDetails(details || []); }, []);

  const handleBack = () => setSelectedDetails(null);
  const columns = useMemo(() => buildColumns(t, handleViewDetails), [t, handleViewDetails]);
  const [searchColumns, setSearchColumns] = useState(() =>
    columns.filter((c) => c.options?.search !== false).map((c) => c.name)
  );
  useEffect(() => {
    setSearchColumns(columns.filter((c) => c.options?.search !== false).map((c) => c.name));
  }, [columns]);




  const fetchData = useCallback(async () => {

    setLoading(true);
    const { success, data, error } = await apiService.search("GET_REPORT_SALES", page + 1, rowsPerPage);

    if (success && data) {
      setLoading(false);
      setData(data);
      setTotalCount(data.TOTAL_COUNT || 0);

      setError("")
    } else {
      setError(error.response.data.message);
      setLoading(false);
    }

  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchData()
  }, [trigger, fetchData]);


  const filteredData = (data?.USER_DETAILS || []).filter((row) => {
    const q = (searchText || "").toLowerCase().trim();
    if (!q) return true;
    return searchColumns.some((name) =>
      row?.[name]?.toString().toLowerCase().includes(q)
    );
  });

  return (
    <ThemeProvider theme={theme}>


      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      <div>
        {!isLoading && (
          <Box mt={4}>
            {selectedDetails ? (<SalesDetails details={selectedDetails} handleBack={handleBack} />) : <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}>



              <SimpleGrid
                className="Total_Header"

                columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
              >


                <div>
                  <FormLabel className="Total_Header_Right" >
                    {t("TOTAL_ORDERS")}
                  </FormLabel>
                  <FormLabel
                    className="Total_Header_Value"

                  >
                    {data.ALL_TOTAL_ORDERS ? data.ALL_TOTAL_ORDERS.toLocaleString() : "0"}
                  </FormLabel>
                </div>
                <div>
                  <FormLabel className="Total_Headers" >
                    {t("TOTAL_SALES")}
                  </FormLabel>
                  <FormLabel
                    className="Total_Header_Value"

                  >
                    {data.ALL_TOTAL_SALES ? data.ALL_TOTAL_SALES.toLocaleString() : "0"}
                  </FormLabel>
                </div>

                <div>
                  <FormLabel className="Total_Headers" >
                    {t("ALL_DISCOUNT_SELL")}
                  </FormLabel>
                  <FormLabel
                    className="Total_Header_Value"

                  >
                    {data.ALL_DISCOUNT_SELL ? data.ALL_DISCOUNT_SELL.toLocaleString() : "0"}
                  </FormLabel>
                </div>
                <div>
                  <FormLabel className="Total_Header_Left" >
                    {t("ALL_SERVICE_SELL")}
                  </FormLabel>
                  <FormLabel
                    className="Total_Header_Value"

                  >
                    {data.ALL_SERVICE_SELL ? data.ALL_SERVICE_SELL.toLocaleString() : "0"}
                  </FormLabel>
                </div>

              </SimpleGrid>

              <TableWidget
                title={t("INVOICE_SALES")}
                data={filteredData}
                onSearchChange={setSearchText}
                columns={columns}
                totalCount={totalCount}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={setPage}
                onRowsPerPageChange={setRowsPerPage}
                searchColumns={searchColumns}
                setSearchColumns={setSearchColumns}
              />

            </div>
            }

          </Box>


        )}
      </div>
    </ThemeProvider >
  );
}

export default App;
